// extracted by mini-css-extract-plugin
module.exports = {"orderClosedTipsBox":"style_orderClosedTipsBox__34Y4V","orderClosedTipsText":"style_orderClosedTipsText__2U58b","orderClosedTipsIcon":"style_orderClosedTipsIcon__1HvSr"};